import {axiosReq} from "../utils/request";


export const signIn = async ({credentials}) => {
  const { email, password } = credentials;
  const basicAuth = 'Basic ' + btoa(email + ':' + password);
  console.log('🔐 Sign-in attempt:', { email, baseURL: process.env.REACT_APP_API_URL });

  const endpoints = [
    { method: 'GET', path: '/sign-in', headers: { Authorization: basicAuth } },
    { method: 'GET', path: '/login', headers: { Authorization: basicAuth } },
    { method: 'POST', path: '/sign-in', data: { email, password } },
    { method: 'POST', path: '/login', data: { email, password } },
  ];

  for (const endpoint of endpoints) {
    try {
      console.log(`📤 Спроба ${endpoint.method} ${endpoint.path}`);
      let res;
      if (endpoint.method === 'GET') {
        res = await axiosReq.get(endpoint.path, { headers: endpoint.headers });
      } else {
        res = await axiosReq.post(endpoint.path, endpoint.data);
      }
      console.log(`✅ Успіх на ${endpoint.method} ${endpoint.path}`);
      return res.data;
    } catch (error) {
      console.log(`❌ ${endpoint.method} ${endpoint.path} - Status ${error.response?.status}`);
      if (endpoints.indexOf(endpoint) === endpoints.length - 1) {
        throw error;
      }
    }
  }
}
export const changePasswordUser = async ({ formChangePass,customerId }) => {
  const formData = formChangePass?.values
  const res = await axiosReq.put(`/change-password/${customerId}`,{...formData})
  return res.data
}

export const getUsers = async () => {
  const res = await axiosReq.get('/users')
  return res.data
}

export const deleteUser = async (removeData) => {
  const res = await axiosReq.delete(`/user/${removeData.id}`)
  return res.data
}

export const editUsers = async ({editUser}) => {
  const res = await axiosReq.patch('/user', {...editUser})
  return res.data
}

export const addUsers = async ({newUser}) => {
  const res = await axiosReq.post('/user', {...newUser})
  return res.data
}
